import React, { Component } from "react";
import { Button, Form, Image } from "react-bootstrap";
import FileComponent from "../ImageUploadComponent";
import { ERROR_MSG, DOCUMENT_FORMATS } from "../../constant";
import IconPin from "../../assets/icon-pin.png";
import Forma from "../../assets/Forma 1.svg";
import { Field } from "../../component";
import { get } from "lodash";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { modifyDataForForwardToTeam } from "./helper";
import { bindActionCreators } from "redux";
import {
  getIssuesCategoryListAction,
  getIssuesSubCategoryListAction
} from "../../actions/common.action";
import { forwardToTeamAction } from "../../actions/issuesListAction.actions";
import { GROUP_KEYS, isValidArray } from "../../helper";
import { getIssueList } from "../../actions/common.action";
import {
  UploadAttachmentsWithTitleComponent
  //DisplayAttachments
} from "../reusableComponent";
import { DisplayAttachments } from "../reusableComponent/displayAttachments/indexForward";
import { handleLanguage, handlePaste, handleQuillLanguage } from "../../helper";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { ConfirmationComponent } from "../ConfirmationComponent";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Delta from "quill-delta";
class ForwardToTeam extends Component {
  state = {
    template: [],
    files: [],
    subCategoryList: [],
    error: {},
    languageError: null,
    pasteError: false,
    pastedText: "",
    comment: "",
    showCommentPopUp: false
  };

  componentDidMount = async () => {
    if (!this.matchersAttached && this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor();
      quill.clipboard.addMatcher("img", () => new Delta());
      quill.clipboard.addMatcher("a", node =>
        //new Delta().insert(node.innerText)
        new Delta().insert(node.textContent || "")
      );
      this.matchersAttached = true;
    }

    const {
      getIssuesCategoryListDispatch,
      issueCategoryList,
      issueDetails
    } = this.props;
    const resp =
      !isValidArray(issueCategoryList) &&
      (await getIssuesCategoryListDispatch(undefined));
    this.setState(
      {
        title: get(issueDetails, "title", "NA"),
        comment: get(issueDetails, "description", "NA"),
        files: get(issueDetails, "files", "NA"),
        error: {
          title: { error: false, message: "" },
          comment: { error: false, message: "" },
          category: { error: false, message: "" },
          subCategory: { error: false, message: "" }
        }
      },
      () => {
        if (resp || issueCategoryList) {
          const category = (resp || issueCategoryList).find(
            value =>
              value.name === get(issueDetails, "category") ||
              value.name === get(issueDetails, "issueCategory")
          );
          this.setState(
            {
              category: get(category, "id")
            },
            () => {
              this.getSubCategoryList();
            }
          );
        }
      }
    );
  };
  onBlur = value => {};
  onChange = (value, key) => {
    const data = { [key]: value };
    if (key === "to") {
      data["groupName"] = value;
    }
    if (key === "category") {
      data["subCategory"] = "";
    }
    this.setState({ ...data }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
  };

  handleChange = (html, delta, source, editor) => {
    const plainText = editor.getText().trim();
    const data = { comment: html }; // since it's for "comment" field
    console.log(data);
    this.setState(
      prevState => ({
        ...prevState,
        ...data
      }),
      () => {
        const { onError } = this;
        if (!plainText) {
          onError(
            { error: true, message: "This field is required" },
            "comment"
          );
        } else {
          onError({ error: false, message: "" }, "comment");
        }

        // 🔹 Detect paste inside React Quill
        if (source === "user" && delta && delta.ops) {
          const isPaste = delta.ops.some(
            op => op.insert && op.insert.length > 1
          );
          if (isPaste) {
            console.log("Is pasted");
            this.pasteLanguage();
          } else if (source === "user") {
            // 🔹 Regular typing
            this.quillInputLanguage(html);
          }
        }
      }
    );
  };

  handleQuillBlur = key => {
    console.log("handleQuillBlur fired");
    const value = this.state[key];
    const { onError } = this;

    // Remove HTML tags & whitespace
    const cleanText = value.replace(/<(.|\n)*?>/g, "").trim();
    console.log("cleanText", cleanText);
    if (!cleanText) {
      console.log("cleanText within", cleanText);
      onError({ error: true, message: "This field is required" }, key);
    } else {
      onError({ error: false, message: "" }, key);
    }
  };

  onError = (value, key) => {
    this.setState(
      prevState => {
        const data = {
          error: {
            ...prevState.error,
            [key]: value
          }
        };
        if (key === "category" && value.error) {
          data["subCategory"] = "";
          data["subCategoryList"] = [];
        }
        return data;
      },
      async () => {
        const { error } = this.state;
        if (key === "category" && !get(error, "category.error")) {
          this.getSubCategoryList();
        }
      }
    );
  };

  getSubCategoryList = async () => {
    const { category } = this.state;
    const { getIssuesSubCategoryListDispatch, issueDetails } = this.props;
    const resp = await getIssuesSubCategoryListDispatch(undefined, {
      issueCategoryId: +category
    });
    if (resp) {
      const { status, data, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      if (isValidArray(data)) {
        const subCategory = data.find(value => {
          return (
            value.name === get(issueDetails, "subCategory") ||
            value.name === get(issueDetails, "issueSubCategory")
          );
        });
        this.setState({
          subCategory: get(subCategory, "id"),
          subCategoryList: data
        });
      }
    }
  };

  returnUploadedImageList = template => {
    this.setState({
      template: template
    });
  };

  onSend = isProjectAwardedByState => {
    const {
      to,
      sendTo,
      error,
      category,
      subCategory,
      title,
      comment
    } = this.state;

    // Clean comment HTML to get only text
    const cleanComment = comment
      ? comment.replace(/<(.|\n)*?>/g, "").trim()
      : "";

    if (
      !error.to ||
      get(error, "to.error") ||
      (!error.comment || get(error, "comment.error")) ||
      (!error.category || get(error, "category.error")) ||
      (!error.subCategory ||
        (!isProjectAwardedByState && get(error, "subCategory.error"))) ||
      (!error.title || get(error, "title.error")) ||
      !cleanComment
    ) {
      this.setState({
        languageError: false,
        pasteError: false,
        error: {
          to: {
            error: !to,
            message: !to && ERROR_MSG.DEFAULT_MSG
          },
          category: {
            error: !category,
            message: !category && ERROR_MSG.DEFAULT_MSG
          },
          subCategory: {
            error: !subCategory,
            message: !subCategory && ERROR_MSG.DEFAULT_MSG
          },
          title: {
            error: !title,
            message: !title && ERROR_MSG.DEFAULT_MSG
          },
          comment: {
            error: !cleanComment,
            message: !cleanComment && ERROR_MSG.DEFAULT_MSG
          }
        }
      });
    } else {
      this.setState({
        sendTo: !sendTo,
        showCommentPopUp: true
      });
    }
  };

  onCloseModal = e => {
    this.setState({ showCommentPopUp: false });
  };
  onDelete = e => {
    this.props.onCloseButton("1");
    const { resetAction } = this.props;
    resetAction(e);
  };

  onSubmit = async e => {
    this.setState({ showCommentPopUp: false });
    const {
      forwardToTeamDispatch,
      issueDetails: { id },
      callApiOnSuccess
    } = this.props;
    console.log("this.state", this.state);
    const data = modifyDataForForwardToTeam({ ...this.state, id });
    const resp = await forwardToTeamDispatch(undefined, data);
    if (resp) {
      const { status, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      this.onDelete(e);
      status && callApiOnSuccess(e);
    }
  };

  onGetFilesData = files => {
    this.setState({
      files
    });
  };

  getImageStatus = status => {
    this.setState({
      imageStatus: status
    });
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      console.error(error.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = index => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  quillInputLanguage = text => {
    const { issueDetails } = this.props;
    const isCentral =
      get(issueDetails, "project.sponsoredByCategory") === "CENTRAL";
    const hasHindi = /[\u0900-\u097F]/.test(text);

    if (isCentral || !hasHindi) {
      const hasInputValue = handleQuillLanguage(text);
      this.setState({
        languageError: hasInputValue,
        pasteError: false,
        comment: text
      });
    } else {
      this.setState({
        languageError: false,
        pasteError: false,
        comment: text
      });
    }
  };

  inputLanguage = event => {
    const { issueDetails } = this.props;
    if (window.event.inputType !== "insertFromPaste") {
      if (
        get(issueDetails, "project.sponsoredByCategory") == "CENTRAL" ||
        !event.target.value.match(/[\u0900-\u097F]/)
      ) {
        let hasInputValue = handleLanguage(event);
        this.setState({
          languageError: hasInputValue,
          pasteError: false,
          comment: event.target.value
        });
      } else {
        this.setState({
          languageError: false,
          pasteError: false,
          comment: event.target.value
        });
      }
    }
  };

  pasteLanguage = () => {
    const { issueDetails } = this.props;
    const { comment } = this.state;
    const plainText = comment.replace(/<[^>]*>/g, "").trim();
    if (
      get(issueDetails, "project.sponsoredByCategory") == "CENTRAL" ||
      !plainText.match(/[\u0900-\u097F]/)
    ) {
      let { filterString, hasBadValue } = handlePaste(this.state.comment);
      console.log("handlepaste result", filterString, hasBadValue);
      if (hasBadValue === true) {
        this.setState({
          pasteError: hasBadValue,
          comment: filterString
        });
      }
    } else {
      this.setState({
        pasteError: false,
        comment: this.state.comment
      });
    }
  };

  render() {
    const {
      template,
      sendTo,
      error,
      subCategoryList,
      category,
      subCategory,
      title,
      comment,
      files,
      languageError,
      pasteError,
      toggleAttachementDisplay,
      showCommentPopUp
    } = this.state;
    const { issueCategoryList, options, issueDetails } = this.props;
    const cleanComment = (comment || "").replace(/<(.|\n)*?>/g, "").trim();

    let isProjectAwardedByState =
      get(issueDetails, "project.sponsoredByCategory") === GROUP_KEYS.STATE;

    const toolbarConfig = {
      toolbar: [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }]]
    };
    const formats = [
      "header",
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
      "image",
      "video"
    ];

    return (
      <div className="forward-to-team">
        {toggleAttachementDisplay ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={toggleAttachementDisplay}
            onCloseModal={this.onToggleAttachment}
            fileFormats={DOCUMENT_FORMATS}
            onSubmit={this.onSuccessUploadOfAttachmets}
          />
        ) : null}
        <div
          // style={{
          //   background: "#F5F5F5",
          //   border: "1px solid #ced7f4",
          //   height: "35px"
          // }}
          className="forward-to-team-main-div"
          style={{
            marginTop: window.location.pathname == "/issue-detail" ? "12px" : ""
          }}
        >
          <h3 className="heading">Forward to Team</h3>
          <div
            className="delete-padding"
            title="Delete"
            onClick={this.onDelete}
            // style={{
            //   width: "17px",
            //   display: "flex",
            //   justifyContent: "flex-end",
            //   position: "relative"
            // }}
          >
            <Image src={Forma} alt="Delet Icon" />
          </div>
        </div>
        <Form
          className={`forward-to-team-form ${
            languageError === true ||
            (pasteError === true && cleanComment !== "")
              ? "language-error-border-alert"
              : (get(error, "to.error") ||
                  get(error, "category.error") ||
                  (!isProjectAwardedByState &&
                    get(error, "subCategory.error")) ||
                  get(error, "title.error") ||
                  get(error, "description.error")) &&
                "error-field"
          }`}
        >
          <div className="forward-to-team-form-content">
            <Form.Group className="field-select field-to">
              <Form.Label>
                To <span className="required">*</span>
              </Form.Label>
              <CustomDropdown
                options={[
                  {
                    value: "",
                    label: "- Select -"
                  },
                  ...(options || []).map(value => ({
                    value: value && value.groupId ? value.groupId : "",
                    label: value && value.groupName ? value.groupName : ""
                  }))
                ]}
                onChange={this.onChange}
                width={"-webkit-fill-available"}
                height={"43px"}
                className={
                  get(error, "to.error") ? "issue-action-error" : "issue-action"
                }
                page={"reassign-for-clarification"}
                menuClassName={"issueActionMenu"}
              />
              {/* <Field
                as="select"
                keyName="to"
                onChange={this.onChange}
                onError={this.onError}
                isInvalid={get(error, "to.error")}
                onBlur={this.onBlur}
              >
                <option value="">- Select -</option>
                {(options || []).map(value => {
                  return (
                    <option
                      value={value.groupId}
                      id={value.groupName}
                      ref={elem => {
                        this.groupElem = elem;
                      }}
                    >
                      {value.groupName}
                    </option>
                  );
                })}
              </Field> */}
            </Form.Group>
            <Form.Group className="field-select">
              <Form.Label>
                Category <span className="required">*</span>
              </Form.Label>
              <Field
                as="select"
                keyName="category"
                onChange={this.onChange}
                onError={this.onError}
                value={category}
                isInvalid={get(error, "category.error")}
                onBlur={this.onBlur}
              >
                <option value="">- Select -</option>
                {(issueCategoryList || []).map(value => {
                  return <option value={value.id}>{value.name}</option>;
                })}
              </Field>
            </Form.Group>

            {isProjectAwardedByState ? null : (
              <Form.Group className="field-select">
                <Form.Label>
                  Sub Category <span className="required">*</span>
                </Form.Label>
                <Field
                  as="select"
                  keyName="subCategory"
                  onChange={this.onChange}
                  onError={this.onError}
                  isInvalid={get(error, "subCategory.error")}
                  value={subCategory}
                  onBlur={this.onBlur}
                >
                  <option value="">- Select -</option>
                  {(subCategoryList || []).map(value => {
                    return <option value={value.id}>{value.name}</option>;
                  })}
                </Field>
              </Form.Group>
            )}
            <Form.Group>
              <Form.Label>
                Title <span className="required">*</span>
              </Form.Label>
              <Field
                type="text"
                keyName="title"
                onChange={this.onChange}
                onError={this.onError}
                isInvalid={get(error, "title.error")}
                value={title}
                onBlur={this.onBlur}
              />
            </Form.Group>
            <Form.Group
              className={files.length !== 0 ? "text-area" : "text-area1"}
            >
              {/* <Field
                as="textarea"
                rows="4"
                keyName="comment"
                onChange={this.onChange}
                onError={this.onError}
                //placeholder="Description"
                isInvalid={get(error, 'comment.error')}
                value={comment}
                onInput={this.inputLanguage}
                onBlur={this.onBlur}
              /> */}
              <div
                className={`quill-wrapper ${
                  get(error, "comment.error") ? "is-invalid" : ""
                }`}
              >
                <ReactQuill
                  value={this.state.comment}
                  onChange={(html, delta, source, editor) =>
                    this.handleChange(html, delta, source, editor)
                  }
                  onBlur={() => this.handleQuillBlur("comment")}
                  isInvalid={get(error, "comment.error")}
                  theme="snow"
                  modules={toolbarConfig}
                  formats={formats}
                  bounds={".app"}
                  ref={el => {
                    this.reactQuillRef = el;
                  }}
                />
              </div>
              {this.state.comment == "" ||
              this.state.comment == "<p><br></p>" ? (
                <>
                  <label
                    for="some-id"
                    className="frwd-to-team-txt-label textfield-fwd__label textfield-fwd__label--required"
                  >
                    Description
                  </label>
                </>
              ) : (
                <></>
              )}
            </Form.Group>
            {files.length !== 0 ? (
              <hr style={{ marginTop: "8px", marginBottom: "0px" }} />
            ) : null}
            <Form.Group className="field-attachment">
              <DisplayAttachments
                filesArr={files}
                //filesArr={meetingOm}
                onRemoveFile={this.onRemoveFile}
                addAttchementRequired={false}
                classes="attachments"
              />
            </Form.Group>
          </div>
          <div className="forward-to-team-footer">
            <div className="forward-to-team-buttons">
              <div className="add-attachment" onClick={this.onToggleAttachment}>
                <div className="add-attachment-button" colSpan={6}>
                  <Image src={IconPin} alt="Attachment Icon" />
                  Add Attachment
                </div>
              </div>
              <div
                //style={{ position: "relative", left: "71%", bottom: "-5px" }}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  position: "relative"
                }}
              >
                <Button
                  className="btn-orange no-padding-send"
                  onClick={() => this.onSend(isProjectAwardedByState)}
                  style={{ marginTop: "10px" }}
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
        </Form>
        {(get(error, "to.error") ||
          get(error, "category.error") ||
          (!isProjectAwardedByState && get(error, "subCategory.error")) ||
          get(error, "title.error") ||
          get(error, "description.error")) && (
          <span className="error invalid-feedback">
            Mandatory fields are missing.
          </span>
        )}
        {languageError === true ||
        (pasteError === true && cleanComment !== "") ? (
          <div className="warning">
            <Image src={CircleWithExclamation} />
            Only English language is supported.
          </div>
        ) : (
          <></>
        )}
        {(showCommentPopUp && (
          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal"}
            saveHandler={this.onSubmit}
            closeHandler={this.onCloseModal}
            content={"Are you sure you want to forward this issue?"}
          />
          // <div className="forward-to-team-confirmation">
          //   <div className="confirmation-inner">
          //     Are you sure you want to forward this issue?
          //     <div className="confirmation-buttons">
          //       <Button className="btn-orange" onClick={this.onSubmit}>
          //         Yes
          //       </Button>
          //       <Button
          //         className="btn-orange-invert"
          //         onClick={() => this.onSend(isProjectAwardedByState)}
          //       >
          //         No
          //       </Button>
          //     </div>
          //   </div>
          // </div>
        )) ||
          null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueCategoryList: state.commonReducer.issuesCategoryList,
    isApiLoading: state.commonReducer.isApiLoading,
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getIssuesCategoryListDispatch: getIssuesCategoryListAction,
      getIssuesSubCategoryListDispatch: getIssuesSubCategoryListAction,
      forwardToTeamDispatch: forwardToTeamAction,
      getIssueListDispatch: getIssueList
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForwardToTeam);
